import clsx from 'clsx'
import { type FC } from 'react'
import { RiContractLeftLine } from 'react-icons/ri'

type Props = {
  collapsed: boolean
  onClick: () => void
}

export const CollapseTrigger: FC<Props> = ({ collapsed, onClick }) => {
  return (
    <div
      className={clsx([
        'flex cursor-pointer justify-end text-gray-1 transition-colors hover:text-primary',
        collapsed ? 'px-1' : 'px-4'
      ])}
      onClick={onClick}
    >
      <div className="p-1">
        <RiContractLeftLine className={clsx([collapsed ? 'rotate-180' : ''])} />
      </div>
    </div>
  )
}
